"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeadlineUiConfig = exports.getDefaultHeadlineUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketRules_1 = require("./../bucketRules");
var bucketHelper_1 = require("./../bucketHelper");
var translations_1 = require("./../translations");
var bucket_title_measures_svg_1 = tslib_1.__importDefault(require("../../assets/headline/bucket-title-measures.svg"));
var bucket_title_secondary_measures_svg_1 = tslib_1.__importDefault(require("../../assets/headline/bucket-title-secondary-measures.svg"));
function getDefaultHeadlineUiConfig() {
    return cloneDeep_1.default(uiConfig_1.DEFAULT_HEADLINE_UICONFIG);
}
exports.getDefaultHeadlineUiConfig = getDefaultHeadlineUiConfig;
function getHeadlineUiConfig(referencePoint, intl) {
    var _a;
    var uiConfig = getDefaultHeadlineUiConfig();
    var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
    var viewCanAddPrimaryItems = bucketRules_1.hasNoMeasures(buckets);
    var viewCanAddSecondaryItems = bucketRules_1.hasNoSecondaryMeasures(buckets);
    uiConfig = bucketHelper_1.setBucketTitles(tslib_1.__assign(tslib_1.__assign({}, referencePoint), { uiConfig: uiConfig }), sdk_ui_1.VisualizationTypes.HEADLINE, intl);
    set_1.default(uiConfig, [bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "canAddItems"], viewCanAddPrimaryItems);
    set_1.default(uiConfig, [bucket_1.BUCKETS, sdk_ui_1.BucketNames.SECONDARY_MEASURES, "canAddItems"], viewCanAddSecondaryItems);
    set_1.default(uiConfig, [bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], bucket_title_measures_svg_1.default);
    set_1.default(uiConfig, [bucket_1.BUCKETS, sdk_ui_1.BucketNames.SECONDARY_MEASURES, "icon"], bucket_title_secondary_measures_svg_1.default);
    var primaryMeasuresCount = bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.MEASURES);
    var secondaryMeasuresCount = bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.SECONDARY_MEASURES);
    if (primaryMeasuresCount === 0 && secondaryMeasuresCount !== 0) {
        uiConfig.customError = {
            heading: translations_1.getTranslation("dashboard.error.missing_primary_bucket_item.heading", intl),
            text: translations_1.getTranslation("dashboard.error.missing_primary_bucket_item.text", intl),
        };
    }
    return uiConfig;
}
exports.getHeadlineUiConfig = getHeadlineUiConfig;
//# sourceMappingURL=headlineUiConfigHelper.js.map